// src/pages/NewsManagement/News.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash, FaSearch, FaTimes, FaCalendar, FaExchangeAlt, FaStar, FaFire } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import Pagination from '../../common/Pagination';
import SearchBar from '../../common/Search';
import { setState } from '../../redux/features/filtersSlice';
import { FaNewspaper, FaPlus } from "react-icons/fa";

import { 
    useGetNewsQuery, 
    useChangeStatusNewsMutation,
    useDeleteNewsMutation 
} from "../../redux/services/newsService/news.Services";
import CommonBreadcrumb from '../../common/CommonBreadcrumb';

function News() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filter = useSelector((state) => state.filters.state);
    const [statusFilter, setStatusFilter] = useState(filter.status || '');
    const [categoryFilter, setCategoryFilter] = useState(filter.category || '');
    const [loadingId, setLoadingId] = useState(null);

    const { data, isLoading, isError, refetch } = useGetNewsQuery({
        ...filter,
        category: categoryFilter,
        status: statusFilter,
    });
    const [changeStatus] = useChangeStatusNewsMutation();
    const [deleteNews] = useDeleteNewsMutation();

    const newsData = data?.data || [];
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const totalItems = pagination?.total || 0;
    const currentPage = pagination?.page || 1;
    const showPagination = totalPages > 1;

    // Format date
    const formatDate = (date) => {
        if (!date) return 'N/A';
        return new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };

    // Get status badge
    const getStatusBadge = (status) => {
        const statusMap = {
            'draft': { class: 'bg-warning', label: 'Draft' },
            'published': { class: 'bg-success', label: 'Published' },
            'archived': { class: 'bg-secondary', label: 'Archived' }
        };
        const statusInfo = statusMap[status?.toLowerCase()] || statusMap['draft'];
        return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
    };

    // Handle status change
    const handleStatusChange = async (id) => {
        if (!id) {
            errorToast('Invalid news ID');
            return;
        }

        if (!window.confirm('Are you sure you want to change the status of this news?')) {
            return;
        }

        try {
            setLoadingId(id);
            const response = await changeStatus(id).unwrap();
            successToast(response?.message || 'Status updated successfully');
            refetch();
        } catch (error) {
            console.error('Status change error:', error);
            errorToast(error?.data?.message || 'Failed to change status');
        } finally {
            setLoadingId(null);
        }
    };

    // Handle delete
    const handleDelete = async (id, name) => {
        if (!id) {
            errorToast('Invalid news ID');
            return;
        }

        if (!window.confirm(`Are you sure you want to delete "${name || 'this news'}"? This action cannot be undone.`)) {
            return;
        }

        try {
            setLoadingId(id);
            const response = await deleteNews(id).unwrap();
            successToast(response?.message || 'News deleted successfully');
            refetch();
        } catch (error) {
            console.error('Delete error:', error);
            errorToast(error?.data?.message || 'Failed to delete news');
        } finally {
            setLoadingId(null);
        }
    };

    const handlePageChange = (page) => {
        dispatch(setState({ page }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSearch = (value) => {
        dispatch(setState({ search: value, page: 1 }));
    };

    const refetchData = () => {
        refetch();
    };

    const handleStatusFilter = (status) => {
        setStatusFilter(status);
        dispatch(setState({ page: 1 }));
    };

    const handleCategoryFilter = (category) => {
        setCategoryFilter(category);
        dispatch(setState({ page: 1 }));
    };

    const clearFilters = () => {
        setStatusFilter('');
        setCategoryFilter('');
        dispatch(setState({ search: '', page: 1 }));
    };

    const handleLimitChange = (e) => {
        dispatch(setState({ limit: parseInt(e.target.value), page: 1 }));
    };

    const handleRefresh = () => {
        refetch();
        successToast("Data refreshed successfully!");
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="mt-3">Loading News...</h5>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="text-center py-5">
                <div className="alert alert-danger">
                    <h5>Something Went Wrong</h5>
                    <p>Unable to load News. Please try again.</p>
                    <button className="btn btn-primary" onClick={handleRefresh}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* HEADER */}
            {/* <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            All News {totalItems > 0 && <span className="badge-custom bg-primary">{totalItems}</span>}
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">All News</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        onClick={() => navigate("/add-news")}
                        className="btn btn-primary me-2"
                    >
                        <i className="fe fe-plus me-1"></i>
                        Add News
                    </button>
                </div>
            </div> */}
<CommonBreadcrumb
    title="All News"
    titleIcon={<FaNewspaper className="me-2 text-primary" />}
    count={totalItems}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "All News" },
    ]}
    buttons={[
        {
            text: "Add News",
            icon: <FaPlus className="me-1" />,
            onClick: () => navigate("/add-news"),
            className: "btn btn-primary",
        },
    ]}
/>
            {/* SEARCH AND FILTER SECTION */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="row g-3 align-items-center">
                        <div className="col-md-3">
                            <SearchBar
                                search={filter.search}
                                setSearch={handleSearch}
                                placeholder="Search News by title..."
                            />
                        </div>

                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => handleStatusFilter(e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="draft">Draft</option>
                                <option value="published">Published</option>
                                <option value="archived">Archived</option>
                            </select>
                        </div>

                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filter.limit}
                                onChange={handleLimitChange}
                            >
                                <option value={5}>5 per page</option>
                                <option value={10}>10 per page</option>
                                <option value={20}>20 per page</option>
                                <option value={50}>50 per page</option>
                            </select>
                        </div>

                        <div className="col-md-5 text-md-end">
                            {(filter.search || statusFilter) && (
                                <button
                                    className="btn btn-outline-secondary me-2"
                                    onClick={clearFilters}
                                >
                                    <FaTimes className="me-1" />
                                    Clear Filters
                                </button>
                            )}
                            <button
                                className="btn btn-outline-primary"
                                onClick={handleRefresh}
                            >
                                Refresh
                            </button>
                        </div>
                    </div>

                    {(filter.search || statusFilter) && (
                        <div className="mt-3 d-flex flex-wrap gap-2">
                            <span className="text-muted me-2">Active Filters:</span>
                            {filter.search && (
                                <span className="badge bg-primary d-flex align-items-center gap-1">
                                    Search: {filter.search}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleSearch('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                            {statusFilter && (
                                <span className="badge bg-info d-flex align-items-center gap-1">
                                    Status: {statusFilter}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleStatusFilter('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* TABLE */}
            <div className="st-wrapper-card">
                {newsData.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-3">
                            <FaCalendar className="text-muted" size={48} />
                        </div>
                        <h5>No News Found</h5>
                        <p className="text-muted">
                            {filter.search || statusFilter
                                ? "Try adjusting your search or filter criteria"
                                : "Click 'Add News' to create your first news"}
                        </p>
                        {(filter.search || statusFilter) && (
                            <button className="btn btn-primary" onClick={clearFilters}>
                                Clear Filters
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>#</th>
                                    <th>Title</th>
                                    <th style={{ width: '120px' }}>Category</th>
                                    <th style={{ width: '120px' }}>Author</th>
                                    <th style={{ width: '130px' }}>Date</th>
                                    <th style={{ width: '100px' }}>Status</th>
                                    <th style={{ width: '80px' }}>Views</th>
                                    <th style={{ width: '200px' }} className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newsData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * filter.limit + index + 1}</td>
                                        <td>
                                            <div className="d-flex align-items-center gap-2">
                                                {item.image_path && (
                                                    <img
                                                        src={item.image_path}
                                                        alt={item.title}
                                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                        className="rounded"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/placeholder-image.png';
                                                        }}
                                                    />
                                                )}
                                                <div>
                                                    <div className="fw-semibold">{item.title || 'N/A'}</div>
                                                    <div className="d-flex gap-1 mt-1">
                                                        {item.is_featured && (
                                                            <span className="badge bg-warning text-dark">
                                                                <FaStar className="me-1" /> Featured
                                                            </span>
                                                        )}
                                                        {item.is_breaking && (
                                                            <span className="badge bg-danger">
                                                                <FaFire className="me-1" /> Breaking
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{item.category || 'N/A'}</td>
                                        <td>{item.author || 'N/A'}</td>
                                        <td>{formatDate(item.created_at)}</td>
                                        <td>{getStatusBadge(item.status)}</td>
                                        <td>{item.view_count || 0}</td>
                                        <td className="text-center">
                                            <button
                                                className="st-action-btn st-view-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-news",
                                                            title: "View News",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="View Details"
                                                disabled={loadingId === item.id}
                                            >
                                                <FaEye />
                                            </button>

                                            <button
                                                className="st-action-btn st-edit-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-news",
                                                            title: "Edit News",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="Edit News"
                                                disabled={loadingId === item.id}
                                            >
                                                <FaEdit />
                                            </button>

                                            <button
                                                className="st-action-btn st-status-btn me-1"
                                                onClick={() => handleStatusChange(item.id)}
                                                title="Change Status"
                                                disabled={loadingId === item.id}
                                            >
                                                {loadingId === item.id ? (
                                                    <span className="spinner-border spinner-border-sm" />
                                                ) : (
                                                    <FaExchangeAlt />
                                                )}
                                            </button>

                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() => handleDelete(item.id, item.title)}
                                                title="Delete News"
                                                disabled={loadingId === item.id}
                                            >
                                                {loadingId === item.id ? (
                                                    <span className="spinner-border spinner-border-sm" />
                                                ) : (
                                                    <FaTrash />
                                                )}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* PAGINATION */}
                {showPagination && newsData.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-4">
                        <div className="text-muted small mb-2 mb-md-0">
                            Showing {((currentPage - 1) * filter.limit) + 1} to{' '}
                            {Math.min(currentPage * filter.limit, totalItems)} of {totalItems} entries
                        </div>
                        <Pagination
                            page={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default News;